import type { VFC } from 'react';
import { useUpdateReseller } from 'api/hooks';
import { InputNumber } from 'components/form/input/InputNumber';
import { Form, Modal } from 'components';
import type { ResellersTrialCreditsFormValues } from '../types/formValues';
import type { ResellersDataItem } from '../queries/getResellersData';

interface ResellerTrialCreditsModalProps {
  readonly reseller: ResellersDataItem;
  readonly onHide: () => void;
  readonly onSuccess: () => void;
}

export const ResellerTrialCreditsModal: VFC<ResellerTrialCreditsModalProps> = ({ reseller, onHide, onSuccess }) => {
  const [form] = Form.useForm<ResellersTrialCreditsFormValues>();
  const { mutate: updateReseller, isLoading: isUpdating } = useUpdateReseller(onSuccess);

  const handleOk = async () => {
    const values = await form.validateFields();
    updateReseller({ id: Number(reseller.id), values });
  };

  return (
    <Modal
      centered
      open
      confirmLoading={isUpdating}
      title={`Trial pool: ${reseller.name}`}
      onCancel={onHide}
      onOk={handleOk}
    >
      <Form form={form} layout="vertical" name="reseller-trial-credits">
        <Form.Item
          initialValue={reseller.trial_establishments_pool_size ?? 0}
          label="Establishments"
          name="trial_establishments_pool_size"
          rules={[{ min: 0, type: 'number', required: true }]}
        >
          <InputNumber controls={false} min={0} precision={0} />
        </Form.Item>
        <Form.Item
          initialValue={reseller.trial_meters_offline_pool_size ?? 0}
          label="Meters offline"
          name="trial_meters_offline_pool_size"
          rules={[{ min: 0, type: 'number', required: true }]}
        >
          <InputNumber controls={false} min={0} precision={0} />
        </Form.Item>
        <Form.Item
          initialValue={reseller.trial_meters_online_pool_size ?? 0}
          label="Meters online"
          name="trial_meters_online_pool_size"
          rules={[{ min: 0, type: 'number', required: true }]}
        >
          <InputNumber controls={false} min={0} precision={0} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
